<template>
    <div>
        <headline-container headline="Create Tag" :breadcrumbs="breadcrumbs"></headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Create Tag
                        </h3>

                        <p>
                            Enter the details of the tag.
                        </p>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit" class="form-horizontal">
                                <text-form-group
                                        v-model="data.name"
                                        name="name"
                                        label="Name"
                                        help-text="The name of the tag."
                                        :error="getError('name')"
                                ></text-form-group>

                                <color-form-group
                                        v-model="data.color"
                                        name="color"
                                        label="Color"
                                        help-text="The color of the tag."
                                        :colors="colors.data"
                                        :error="getError('color')"
                                ></color-form-group>

                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import ColorFormGroup from '@/components/FormGroups/Horizontal/Color'
    import Errors from '@/mixins/Errors'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {ColorFormGroup, HeadlineContainer, HelpText, LoadingContainer, SubmitFormGroup, TextFormGroup},

        mixins: [Errors, Load],

        data() {
            return {
                data: {},
                colors: []
            }
        },

        mounted() {
            this.load({colors: '/api/v2/colors'})
        },
        
        computed: {
            breadcrumbs() {
                return [
                    {url: '/tags', text: 'Tags'},
                    {text: 'Create'}
                ]
            }
        },

        methods: {
            submit() {
                http.post('/api/v2/tags', this.data)
                    .then(() => {
                        notify.success('The tag was saved')

                        this.$router.push('/tags')
                    })
                    .catch(this.catchValidationErrors)
            }
        }
    }
</script>
